// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-form[data-v-2a0e284d]{position:relative;top:0;right:0;bottom:0;left:0}.ui-form .ui-form__processing[data-v-2a0e284d]{display:flex;align-items:center;justify-content:center;position:absolute;top:0;right:0;bottom:0;left:0;z-index:11}\n", ""]);
// Exports
module.exports = exports;
